<script>
import { uniq } from "lodash";
import Modal from "@/components/g-modal.vue";
import CommentsList from "./comments-list.vue";
import { filterSysComOut } from "../../../config/comments.config";

export default {
  components: {
    CommentsList,
    Modal
  },
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    current: {
      type: Object,
      default: () => ({})
    },
    responsible: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      commentsModal: {
        opened: false
      }
    };
  },
  computed: {
    approvers() {
      const responsaveis = this.responsible ?? [];
      const niveisHierarquicos = this.current?.revisores ?? [];
      const workflowResponsible = responsaveis.filter(
        ({ workflow_id }) => this.current?.id === workflow_id
      );
      let targetArray = workflowResponsible.length
        ? workflowResponsible
        : niveisHierarquicos;
      targetArray = targetArray.map(
        ({ nome, responsavel }) => nome || responsavel.nome
      );
      targetArray = uniq(targetArray);
      let responsibleLabel = "não definido";

      if (targetArray.length > 1) {
        const lastOne = targetArray.pop();
        responsibleLabel = targetArray.join(", ") + ` e ${lastOne}`;
      } else if (targetArray.length) {
        const [first] = targetArray;
        responsibleLabel = first;
      }

      return {
        label: targetArray.length > 1 ? "Aprovadores:" : "Aprovador:",
        value: responsibleLabel
      };
    },
    showApprovers() {
      return (
        this.responsible?.length > 0 || this.current?.revisores?.length > 0
      );
    },
    /**
     * Lista de comentários dos usuários
     * @type {import('../../config/comments.config').Comment[]}
     * @readonly
     */
    userComments() {
      return this.comments?.filter(filterSysComOut) ?? [];
    },
    workflowName() {
      return this.current?.nome ?? "";
    }
  }
};
</script>

<template>
  <div class="workflow-display">
    <div class="workflow-display-item workflow-icon">
      <v-icon color="white" dense>mdi-chart-timeline</v-icon>
    </div>
    <div class="workflow-display-item d-flex flex-column">
      <div>
        <span class="workflow-label">Status do workflow: </span>
        <span class="workflow-value">{{ workflowName }}</span>
      </div>
      <div v-if="showApprovers">
        <span class="workflow-label">{{ approvers.label }} </span>
        <span class="workflow-value">{{ approvers.value }}</span>
      </div>
    </div>

    <v-badge
      v-if="userComments.length"
      class="workflow-display-item"
      :color="tableColor"
      :content="userComments.length"
      offset-y="16"
      offset-x="20"
      :value="userComments.length"
    >
      <v-btn :color="tableColor" text @click="commentsModal.opened = true">
        Ver comentários
      </v-btn>
    </v-badge>

    <Modal
      v-model="commentsModal.opened"
      hide-buttons
      title="Comentários por etapa"
      width="600px"
    >
      <CommentsList :comments="userComments" />
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.workflow-display {
  align-items: center;
  display: flex;
  flex-direction: row;
  min-height: 2.25rem;

  .workflow-display-item + .workflow-display-item {
    margin-left: 0.5rem;
  }

  .workflow-icon {
    background-color: #ffc440;
    border-radius: 50%;
    color: #fff;
    font-size: 1.15rem;
    height: 2.25rem;
    line-height: 2;
    text-align: center;
    width: 2.25rem;
  }

  .workflow-label {
    font-weight: bold;
  }

  .workflow-value {
    font-weight: 300;
  }
}
</style>
